module.exports = __webpack_public_path__ + "static/media/no-shady-permissions.215f4566.svg";